import { clsx } from 'clsx';
import React from 'react';
import type { ContactList } from '../../../../../js/api';
import { formatContactPhone, formatContactSortName, pluralize } from './contactDisplay';

export const ContactCard: React.FC<{
  contact: ContactList;
  isSelected?: boolean;
  showOrganization?: boolean;
  selectControl?: React.ReactNode;
}> = ({ contact, isSelected = false, showOrganization = false, selectControl }) => {
  const phone = formatContactPhone(contact);
  return (
    <div
      className={clsx(
        'tw:h-full tw:bg-white tw:rounded-lg tw:shadow-sm tw:border tw:border-zinc-200 tw:hover:shadow-md tw:hover:bg-muted tw:transition-shadow tw:cursor-pointer',
        isSelected && 'tw:!bg-brand-green-0/10 tw:!shadow-md'
      )}
    >
      <div className="tw:p-3">
        <div className="tw:flex tw:items-start tw:gap-2 tw:mb-2">
          {selectControl}
          <p className="tw:!text-[16px] tw:font-semibold tw:text-zinc-900 tw:!mb-0 tw:line-clamp-2">
            <i className="far fa-fw fa-lg fa-address-card tw:mr-1" />
            {formatContactSortName(contact)}
          </p>
        </div>
        {showOrganization && contact.healthcare_entity_name && (
          <div className="tw:mb-1 tw:text-sm tw:text-zinc-600">
            <span className="tw:truncate tw:italic">{contact.healthcare_entity_name}</span>
          </div>
        )}
        <div className="tw:flex tw:items-center tw:gap-2 tw:mb-1 tw:text-sm tw:text-zinc-600">
          <i className="far fa-fw fa-envelope tw:text-zinc-400" />
          <span className="tw:truncate">{contact.email}</span>
        </div>
        {phone && (
          <div className="tw:flex tw:items-center tw:gap-2 tw:mb-1 tw:text-sm tw:text-zinc-600">
            <i className="far fa-fw fa-phone tw:text-zinc-400" />
            <span>{phone}</span>
          </div>
        )}
        <div className="tw:mt-2">
          <span className="tw:inline-flex tw:items-center tw:px-2 tw:py-0.5 tw:rounded tw:text-xs tw:bg-zinc-100 tw:text-zinc-700">
            {pluralize(contact.facility_count ?? 0, 'facility', 'facilities')}
          </span>
        </div>
      </div>
    </div>
  );
};
